import { render, staticRenderFns } from "./GeneralSettingIndex.vue?vue&type=template&id=143440e1&scoped=true&"
import script from "./GeneralSettingIndex.vue?vue&type=script&lang=js&"
export * from "./GeneralSettingIndex.vue?vue&type=script&lang=js&"
import style0 from "./GeneralSettingIndex.vue?vue&type=style&index=0&id=143440e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143440e1",
  null
  
)

export default component.exports